import React from 'react';
import { BrandBook } from './pages/BrandBook';
export function App() {
  return <BrandBook data-id="element-0" />;
}